var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgRounded3 = function SvgRounded3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1600 200",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1610.5 189.1s-128.2-82.6-138.2-89.2c-17.1-11.3-37.2-15.5-87-18.1-49.7-2.6-753.6-40.7-783.9-42.3-30.3-1.5-81.1-1.3-121.1 8.2S-9.5 163.2-9.5 163.2v50h1620v-24.1z"
  })));
};
export default SvgRounded3;